import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { fixEvent } from '../utils/eventUtils';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  static userSearch(q: string, selected_page: number) {
    throw new Error('Method not implemented.');
  }
  private baseApiUrl = '/api/';

  constructor(private http: HttpClient) {}

  get(url: string, params?: any): Observable<any> {
    return this.http.get(this.baseApiUrl + url, { params });
  }

  post(url: string, data: any): Observable<any> {
    return this.http.post(this.baseApiUrl + url, data);
  }

  patch(url: string, data: any): Observable<any> {
    return this.http.patch(this.baseApiUrl + url, data);
  }

  delete(url: string): Observable<any> {
    return this.http.delete(this.baseApiUrl + url);
  }

  userSearch(query: string, page: number): Observable<any> {
    const params = new HttpParams().set('q', query).set('page', page.toString());
    return this.get('user', { params });
  }

  userSearchEmail(email: string): Observable<any> {
    const params = new HttpParams().set('email', email);
    return this.get('user', { params });
  }

  deviceList(page: number, from: string, model: string, filter: any): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('from', from)
      .set('model', model)
      .set('filter', JSON.stringify(filter));
    return this.get('device', { params });
  }

  deviceEdit(id: string, editedFields: any): Observable<any> {
    return this.patch('device/' + id, editedFields);
  }

  location(id: string): Observable<any> {
    return this.get('location/' + id).pipe(
      map(result => {
        const data = result.data;
        fixLocation(data);
        return data;
      })
    );
  }

  locationTimeline(id: string, page: number): Observable<any> {
    const params = new HttpParams().set('page', page.toString());
    return this.get('location/' + id + '/event', { params }).pipe(
      map(result => {
        const items = result.data.items;
        items.forEach((event:any) => {
          fixEvent(event);
        });
        for (let i = 0; i < items.length - 1; i++) {
          items[i].delta = diff(items[i + 1].created_time, items[i].created_time);
        }
        return result;
      })
    );
  }

  locationMembers(id: string, page: number): Observable<any> {
    const params = new HttpParams().set('page', page.toString());
    return this.get('location/' + id + '/member', { params });
  }

  adminLogs(page: number, from: string): Observable<any> {
    const params = new HttpParams().set('page', page.toString()).set('from', from);
    return this.get('log', { params });
  }


  
  getUserData(): Observable<any> {
    // Make an API request to fetch the user data
    return this.http.get('/api/user-data');
  }
  
}

function fixLocation(location: any) {
  // Logic to fix location data goes here
}


function diff(date1: string, date2: string): number {
  // Logic to calculate time difference between two dates goes here
  return 0; // Placeholder return value, replace with your implementation
}

